import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import './style.scss'

export default class AddressCell extends Component {
    static propTypes = {
        address: PropTypes.string.isRequired,
        country: PropTypes.string.isRequired,
    }

    render() {
        const { address, country } = this.props

        return (
            <div className={'group-table-address-cell'}>
                <div className={cx('flag-icon', `flag-icon-${country}`)} />
                <div className={'text'}>{address}</div>
            </div>
        )
    }
}
